module.exports = __webpack_public_path__ + "img/mu.3cbf1387.svg";